import * as React from 'react';
import { formatPhone, formatPhoneLink } from '../../../../utils/formatters';

import * as styles from './PhoneNumber.css';

export interface IPhoneNumberProps {
  phone: string;
}

export const PhoneNumber: React.VFC<IPhoneNumberProps> = ({ phone }) => {
  return (
    <a className={styles['phone-number']} href={formatPhoneLink(phone)} data-testid="PhoneNumber">
      {formatPhone(phone)}
    </a>
  );
};
